// PptViewer.jsx
import React from 'react';
import {
    Viewer,
    Worker,
    SpecialZoomLevel,
} from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const PptViewer = () => {
    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        sidebarTabs: () => [], // Hide sidebar if you want a cleaner view
    });

    return (
        <>
            <div style={{ height: '100vh', backgroundColor: '#F7F7F7', paddingTop: '56px', marginTop: '-56px' }}>
                <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}>
                    <Viewer
                        fileUrl={process.env.PUBLIC_URL + '/Digital_Transformation_112019_web.pdf'}
                        plugins={[defaultLayoutPluginInstance]}
                        defaultScale={SpecialZoomLevel.PageFit}
                        defaultScrolling={"horizontal"}
                    />
                </Worker>
            </div>
        </>
    );
};

export default PptViewer;
